import { PenaltiesService } from '@fair-play/infra';
import { inject } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { GetUserPenaltiesPathParams, GetUserPenaltiesResponse, PenaltyType } from '@core-http';

export class IsRedCardActiveQueryHandler {
  private readonly penaltiesService: PenaltiesService = inject(PenaltiesService);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  isRedCardActive(): Observable<boolean> {
    return this.userDataProvider.userData$.pipe(
      switchMap((userData: UserModel) => {
        const pathParams: GetUserPenaltiesPathParams = { userId: userData.userId };
        return this.penaltiesService.getPenalties(pathParams);
      }),
      map((dto: GetUserPenaltiesResponse) => dto.activePenalty?.penaltyType === PenaltyType.RED)
    );
  }
}
